import './styles.scss'

import React, { Component } from 'react'

class Grid extends Component {
  constructor(props) {
    super(props)
    this.state = { gridIsOn: false }
  }
  onTriggerClick() {
    const { gridIsOn } = this.state
    this.setState({ gridIsOn: !gridIsOn })
  }
  render() {
    const { gridIsOn, showDevices } = this.state
    let grid = (
      <div className="grid">
        {
          showDevices &&
            <div className="devices">
              <span className="smartphone" />
              <span className="iPad-portrait" />
              <span className="iPad-landscape" />
            </div>
        }
        <span className="desktop" />
      </div>
    )
    let trigger = (
      <span
        className="grid-trigger"
        onClick={this.onTriggerClick.bind(this)}
      />
    )
    return (
      <div className="grid-cont">
        {trigger}
        {gridIsOn ? grid : null}
      </div>
    )
  }
}

export default Grid



// WEBPACK FOOTER //
// ./src/grid/grid.js